import { render, staticRenderFns } from "./VisionCollection.vue?vue&type=template&id=728cf6b0"
import script from "./VisionCollection.vue?vue&type=script&lang=js"
export * from "./VisionCollection.vue?vue&type=script&lang=js"
import style0 from "./VisionCollection.vue?vue&type=style&index=0&id=728cf6b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports